/** The result of a play-sound (find-device) request as acknowledged by the walt. */
export enum WaltSoundStatusType {
    /** The walt started playing the find-device sound. */
    Playing = 'playing',
    /** The walt user silenced the find-device sound. */
    Stopped = 'stopped',
    /** The walt could not play the find-device sound. */
    Failed = 'failed',
}

/** Why a play-sound request failed. */
export enum WaltSoundFailureReason {
    /** Higher priority audio was already playing on the walt. */
    HigherPriorityAudio = 'higher-priority-audio',
    /** The walt did not acknowledge the request in time (device unreachable). */
    Unreachable = 'unreachable',
}

/** Payload the walt sends to acknowledge a play-sound request. */
export interface WaltSoundStatusReport {
    status: WaltSoundStatusType;
    reason?: WaltSoundFailureReason;
}

/** Payload sent to the walt when a play-sound request is triggered remotely. */
export interface WaltSoundRequest {
    /** Display name of the admin who triggered the sound, shown on the walt. */
    name?: string;
}

/** Payload sent to the walt when a Console admin restarts, powers off or updates it. */
export interface WaltCommandRequest {
    /** Display name of the Console user who sent the command. */
    name?: string;
    /** ISO time the command was sent. */
    sentAt: string;
}

/** Event relayed to the console with the play-sound acknowledgment status. */
export interface WaltSoundStatusEvent extends WaltSoundStatusReport {
    waltId: string;
    date: Date | string;
}
